import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatRipple } from '@angular/material/core';

@Component({
  selector: 'archived-order-modal',
  templateUrl: './archived-order-modal.component.html',
  styleUrls: ['./archived-order-modal.component.scss'],
  imports: [MatRipple],
})
export class ArchivedOrderModalComponent {
  private dialogRef =
    inject<MatDialogRef<ArchivedOrderModalComponent>>(MatDialogRef);

  public close(): void {
    this.dialogRef.close();
  }
}
